import { fork } from 'redux-saga/effects';

import userHandlerSagas from './containers/user-handler/sagas';
import CampaignsListSaga from './containers/influencers-campaign-list/sagas';
import CamapignSaga from './containers/campaign/sagas';
import DiscussionSaga from './containers/discussion/sagas';
import DiscussionsListSaga from './containers/discussion-list/sagas';
import CampaignManageMembersSaga from './containers/campaign-members-manage/sagas';
import DeliverableAssignSaga from './containers/deliverable-assign-modal/sagas';
import DeliverableSubmitSaga from './containers/deliverable-submit-modal/sagas';
import DocumentUploadSaga from './containers/document-upload-modal/sagas';
import TrackAssetSaga from './containers/track-asset-modal/sagas';
import AnalyticsAssetListSaga from './containers/analytics-asset-list/sagas';
import DeliverableSaga from './containers/deliverable/sagas';
import InfluencersSaga from './containers/influencers/sagas';
import UserSettingsSaga from './containers/user-settings/sagas';
import CampaignAnalytics from './containers/campaign-analytics/sagas';
import PaymentsSagas from './containers/payments/sagas';
import CampaignInviteSagas from './containers/campaign-invite/sagas';
import UserOnboardingStateSagas from './containers/user-onboarding-state/sagas';
import SendBriefAllSagas from './containers/send-brief-all-modal/sagas';
import SendDeliverableAllSagas from './containers/send-deliverable-all-modal/sagas';

// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield [
    fork(userHandlerSagas),
    fork(CampaignsListSaga),
    fork(CamapignSaga),
    fork(DiscussionsListSaga),
    fork(DiscussionSaga),
    fork(CampaignManageMembersSaga),
    fork(DeliverableAssignSaga),
    fork(DeliverableSubmitSaga),
    fork(DocumentUploadSaga),
    // fork(SendbirdSaga),
    fork(TrackAssetSaga),
    fork(AnalyticsAssetListSaga),
    fork(DeliverableSaga),
    fork(InfluencersSaga),
    fork(UserSettingsSaga),
    fork(CampaignAnalytics),
    fork(PaymentsSagas),
    fork(CampaignInviteSagas),
    fork(UserOnboardingStateSagas),
    fork(SendBriefAllSagas),
    fork(SendDeliverableAllSagas),
  ];
}



/** WEBPACK FOOTER **
 ** ./src/sagas.js
 **/